var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Stats","operations":_vm.operations,"filters":_vm.filters,"fields":_vm.fields,"response":_vm.data,"working_th_searches":_vm.working_th_searches},on:{"thFilter":_vm.thFilter,"create":_vm.createStat,"done":_vm.done,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }